<template>
  <div>
    <img class="img"
         src="@/assets/images/power.jpg" />
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
}
</script>

<style scoped>
.img {
  margin: 20% 0 0 40%;
  width: 30%;
  height: 100%;
}
</style>
